import { BaSeContainer } from '@base/react';
import styled from 'styled-components';

export const Container = styled(BaSeContainer)`
  max-height: 50vh;
  padding-top: 30px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  padding-top: 30px;
`;
